import SEO from "../componentsNew/SEO/SEO";
import HeaderLarge from "../components/page-title/header-large";
import About from "../components/home/about";
import Values from "../components/home/values";
import ServiceOverview from "../components/home/services-overview";
import References from "../components/home/references";
import DataValues from "../components/home/data/values";
import DataProjects from "../components/services/data/overview";
import DataRefs from "../components/references/data/Data";
import Footer from "../components/footer/Footer";
import Cta from "../components/call-to-actions/cta";
import MobileNav from "../layout/nav/mobileNav";
import Nav from "../layout/nav/desktopNav";

const Index = () => {
  return (
    <>
      <SEO
        title="Decoratie Degezelle - Schilderwerken"
        description="Ontdek een uitgebreid overzicht van onze diensten en bekijk onze recente projecten."
        keywords="schilder, schilderwerken, in de buurt"
        canonical="/website"
      />
      <Nav />
      <MobileNav />
      <HeaderLarge
        title="schilder & decoratiewerken"
        subtitle="Verf je wereld binnen & buiten!"
        text="Stap binnen en ervaar de kunst van schilderen bij Decoratie Degezelle. Wij transformeren niet alleen muren, maar creëren een levendige sfeer die jouw stijl weerspiegelt. Ontdek onze expertise, laat je inspireren en geef kleur aan jouw wereld."
        color="transparent"
        showCarousel={true}
      />
      <About />
      <ServiceOverview items={DataProjects} />
      <Values items={DataValues} />
      <References items={DataRefs} />
      <Cta />
      <Footer />
    </>
  );
};

export default Index;
